import React from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Media,
    CardBody
} from "reactstrap";
// core components
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReduxBlockUi from "react-block-ui/redux";
import "react-block-ui/style.css";

import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unit/EditRedux";
import { Actions as TaskActions } from "../../../redux/TaskRedux";
import { TaskTypes } from "../../../utils/TaskHelper"
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
// import UnitForms from "./forms";
import UnitForm from "./forms/UnitForm";
import UIDs from "../../../UIDs";
import * as UnitHelper from "../../../utils/UnitHelper";
import { HotKeys } from "react-hotkeys";
// import $ from "jquery";
import { StickyContainer } from "react-sticky";

import "../../../assets/scss/screens/admin/unit/unit.scss";

const uid = UIDs.screens.admin.unit.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_ASYNC]: { done: this._handleSaveUnitAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC]: { done: null, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            isOnComposition: false
        };

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, unitData } = this.localVars.navParams;
        this.props.loadScreenViewAsync(id || "");

        if (unitData) {
            this.props.loadTaskUnitData(unitData);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        let hotkeysScope = this.refs.hotkeysScope;
        hotkeysScope && hotkeysScope.focus();

        let filterTemp = this.refs.filterTemp;
        filterTemp && filterTemp.focus();
        setTimeout(function(){
            // $("input[name="duration"]").focus();
        },500)
    }

    hotkeysKeyMap = {
        CANCEL: "alt+q",
    }

    hotkeysHandler = {
        CANCEL: () => this._handleCancelEdit(),
    }

    render() {
        // before initialization is done, we show loading icon
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <LoadingIndicator />;
        }

        const { unitTypeList, unitTypeListById, unit, resourceId } = this.props.localState;

        const newUnitTypeList = UnitHelper.buildTypeList(unitTypeListById != null ? unitTypeListById : unitTypeList);

        let formBody = null;

        // if we are creating a new unit, we should show unit type to select first
        if (Helper.isNullOrEmpty(this.localVars.navParams.id)
            && !unit.unitType) {
            formBody = (
                <Row>
                    <Col>
                        {newUnitTypeList ?
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <InputGroup size="sm">
                                                <input className="form-control"
                                                    ref="filterTemp"
                                                    autoFocus={true}
                                                    onChange={(e) => this._handleSearch(e)}
                                                    placeholder={this.props.t("filterTemp")} />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText><i className="fas fa-search" /></InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button
                                                color="default"
                                                onClick={this._handleCancelEdit}
                                                size="sm">
                                                {this.props.t("cancel") + "(Q)"}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <div style={{ marginTop: "-15px" }}>
                                            {
                                                newUnitTypeList.map((item) => {
                                                    this.hotkeysKeyMap[`${item.id}`] = [`${item.id[0].toLowerCase()} ${item.id[1]}`, `${item.id[0].toUpperCase()} ${item.id[1]}`];
                                                    this.hotkeysHandler[`${item.id}`] = () => { this.props.selectUnitType(item) };
                                                    return (
                                                        <div style={{ float: "left", marginTop: "8px", marginBottom: "8px", marginLeft: "8px" }}>
                                                            <Button
                                                                onClick={() => { this.props.selectUnitType(item) }}
                                                                style={{ paddingLeft: "13px", paddingRight: "13px", paddingTop: "10px", paddingBottom: "10px", backgroundColor:"#fff" }}
                                                            >
                                                                <Media>
                                                                    <img src={item.imageUrl} alt="..." style={{ width: "110px", height: "190px" }} />
                                                                </Media>
                                                            </Button>
                                                            <div style={{ marginTop: "5px", textAlign: "center", fontSize: "12px" }}>{item.id + ":" + item.title}</div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </Row>
                                </CardBody>
                            </Card> : null
                        }

                    </Col>
                </Row>

            );
        } else {
            formBody = (
                <StickyContainer style={{ width: "100%" }}>
                    <Row>
                        <Col className="aic-singleUnit-style">
                            <ReduxBlockUi tag="div" block={[ActionTypes.SAVE_UNIT_ASYNC, ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC]} unblock={[ActionTypes.SAVE_UNIT_SUCCESS, ActionTypes.SAVE_UNIT_FAILURE, ActionTypes.SAVE_AND_CREATE_UNIT_SUCCESS, ActionTypes.SAVE_AND_CREATE_UNIT_FAILURE]}>
                                <UnitForm hotkeysHandler={this.hotkeysHandler} data={{ unitType: unit.unitType, formData: unit.data, commonFieldValues: { duration: unit.duration, cover: unit.cover, title: unit.data.title }, id: unit.id }} resourceId={resourceId} onCancel={this._handleCancelEdit} onSave={this._handleSaveUnitAsync} onSaveAndCreate={this._handleSaveAndCreateUnitAsync} />
                            </ReduxBlockUi>
                        </Col>
                    </Row>
                </StickyContainer>
            );
        }

        return (
            <HotKeys keyMap={this.hotkeysKeyMap} handlers={this.hotkeysHandler}>
                <div ref="hotkeysScope" tabindex="0">
                    <Container className="mt--7" fluid>
                        {formBody}
                    </Container>
                </div>
            </HotKeys>
        );
    }


    _handleCancelEdit = () => {
        confirmAlert({
            title: this.props.t("confirmToCancel"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this._handleGoBack();
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveUnitAsync = formData => {
        const { unit, resourceId } = this.props.localState;
        const { id, unitType, data } = unit;
        //const { sectionId } = this.localVars.navParams;
        const { ownerType = unit.ownerType, ownerId = unit.ownerId } = this.localVars.navParams;

        //let vo = { id, unitType, sectionId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }), ...formData.commonFieldValues };
        let vo = { id, unitType, ownerType, ownerId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }), ...formData.commonFieldValues };

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        if (unit.taskId) {
                            this.props.deleteFailedTask(unit.taskId);
                        }

                        const { syncSave } = this.localVars.navParams;
                        if (syncSave) {
                            this.props.saveUnitAsync(vo);
                        }
                        else {
                            this.props.addSaveUnitTask(vo);
                            this._handleGoBack();
                        }
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveAndCreateUnitAsync = formData => {
        const { unit, resourceId } = this.props.localState;
        const { id, unitType, data } = unit;
        //const { sectionId } = this.localVars.navParams;
        const { ownerType = unit.ownerType, ownerId = unit.ownerId } = this.localVars.navParams;

        //let vo = { id, unitType, sectionId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }), ...formData.commonFieldValues };
        let vo = { id, unitType, ownerType, ownerId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }), ...formData.commonFieldValues };

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        if (unit.taskId) {
                            this.props.deleteFailedTask(unit.taskId);
                        }
                        this.props.addSaveUnitTask(vo);
                        this.props.recreate();
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleGoBack = () => {
        const { unit } = this.props.localState;
        const { pageIndex, ownerId = unit.ownerId } = this.localVars.navParams;

        if(pageIndex === undefined){
            if (window.history.length > 2) {
                NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
            } else {
                // NOTE: 当通过链接直接打开编辑页面时, 不能返回到上一页, 跳转到首页
                window.location.href = "/";
            }
        }else{
            //跳回验证页面
            window.location.href = "/mobile/checkunit?sectionId="+ownerId+"&pageIndex="+pageIndex;
        }
    }

    _handleSaveUnitAsyncDone = () => {
        this._handleGoBack();
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }

    _handleSearch = (e) => {
        this.props.searchByTypeId(e.target.value);
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveUnitAsync: vo => dispatch(Actions.saveUnitAsync(vo)),
        selectUnitType: unitType => dispatch(Actions.selectUnitType(unitType)),
        selectTypeList: typeList => dispatch(Actions.selectTypeList(typeList)),
        saveAndCreateUnitAsync: vo => dispatch(Actions.saveAndCreateUnitAsync(vo)),
        addSaveUnitTask: vo => dispatch(TaskActions.addTask(vo, TaskTypes.SAVE_UNIT)),
        deleteFailedTask: id => dispatch(TaskActions.deleteTask(id, TaskTypes.SAVE_UNIT)),
        loadTaskUnitData: (unitData) => dispatch(Actions.loadTaskUnitData(unitData)),
        recreate: () => dispatch(Actions.recreate()),
        searchByTypeId: id => dispatch(Actions.searchByTypeId(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
